<template>
  <div class="pagination-container" v-if="total > 0">
    <el-pagination
      background
      :current-page="page"
      :page-size="limit"
      :page-sizes="pageSizes"
      :layout="layout"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50]
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('update:limit', val)
      // 切换每页数量时通常需要回到第一页
      this.$emit('update:page', 1)
      this.$emit('pagination', { page: 1, limit: val })
    },
    handleCurrentChange(val) {
      this.$emit('update:page', val)
      this.$emit('pagination', { page: val, limit: this.limit })
    }
  }
}
</script>

<style scoped>
.pagination-container {
  padding: 16px 0;
  display: flex;
  justify-content: flex-end;
}
</style>

